import axios from 'axios';
import i18n, { GEO_COUNTRY_KEY } from '../i18n';

// El backend manda los correos transaccionales en el idioma del receptor y una
// de sus señales es la geolocalización. Traefik/Easypanel no inyecta headers de
// país, así que la señal la pone el cliente: detectLanguageByGeo ya resolvió el
// país por geo-IP y lo dejó cacheado en localStorage.
//
// Van como headers (no en el body) para que apliquen a cualquier request sin
// tocar cada payload. Los lee backend/src/lib/emailLang.js.
export function syncGeoHeaders() {
  try {
    const country = localStorage.getItem(GEO_COUNTRY_KEY);
    if (country) axios.defaults.headers.common['X-Troly-Country'] = country.toUpperCase();
  } catch { /* localStorage bloqueado: seguimos sin la señal de país */ }

  const lang = (i18n.language || '').slice(0, 2);
  if (lang) axios.defaults.headers.common['X-Troly-Lang'] = lang;
}

// Sincroniza al arrancar y en cada cambio de idioma, para que un correo
// disparado justo después del cambio ya salga en el idioma nuevo.
export function startGeoHeaderSync() {
  syncGeoHeaders();
  i18n.on('languageChanged', syncGeoHeaders);
}
